import React from 'react';
import Help from '@material-ui/icons/Help';
import IconCompose from '../icons/iconCompose';
import IconNotifications from '../icons/iconNotifications';

export const actions = [
  {
    name: 'compose',
    label: 'Compose',
    renderIcon: () => (
      <IconCompose />
    ),
    link: '/new-post',
    comingSoon:false,
  },
  {
    name: 'notifications',
    label: 'Notifications',
    isDisabled: true,
    renderIcon: (isDisabled) => (
      <IconNotifications />
    ),
    comingSoon:true,
  },
  {
    name: 'help',
    label: 'Help Center',
    renderIcon: () => (
      <Help htmlColor="rgba(29, 56, 83, 0.8)" />
    ),
    onClick: () => {
      window.open('https://brandcil.zendesk.com/hc', 'authWindow', 'height=500,width=500,top=200,left=200');
    },
    comingSoon:false,
  }
];

export default actions;
